import { CustomField } from "@/Features/CustomFields/custom-fields.types";
import { ImportFieldDefinition } from "../../_components/DataImport";

export function resolveCapacityValue(value: string): number | string {
  const sizeWithUnitPattern = /^\s*(\d+(?:\.\d+)?)\s*(B|KB|MB|GB|TB|PB)\s*$/i;
  const match = value.match(sizeWithUnitPattern);

  if (!match) {
    const num = Number(value);
    return isNaN(num) ? value : num;
  }

  return Number(match[1]);
}

export function resolveCapacityUnitValue(value: string): string | undefined {
  const sizeWithUnitPattern = /^\s*(\d+(?:\.\d+)?)\s*(B|KB|MB|GB|TB|PB)\s*$/i;
  const sizeMatch = value.match(sizeWithUnitPattern);

  if (sizeMatch) {
    return sizeMatch[2].toUpperCase();
  }

  return undefined;
}

export function parseTagBoxCsvValue(value: string): string[] {
  return value
    .split(/[;,|\n]/)
    .map((entry) => entry.trim())
    .filter((entry) => entry.length > 0);
}

export function mapCustomFieldEditorType(
  editorType: CustomField["editor_type"]
): ImportFieldDefinition["type"] {
  switch (editorType) {
    case "textBox":
      return "text";
    case "dropDown":
      return "select";
    case "dateBox":
      return "date";
    case "tagBox":
      return "select";
    default:
      return "text";
  }
}
